/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2020 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React from 'react';

import { FormattedOperator } from '../types';
import {
  OperatorContainer,
  OperatorImage,
  OperatorLabel,
  OperatorInformations
} from '../styles/components';
import { LinkArrow } from 'shared/components/presentational/Icons/components';

interface Props {
  operator: FormattedOperator;
  inactive: boolean;
}

const Operator = ({
  operator: { label, imageUrl, imageAlt },
  inactive
}: Props) => (
  <OperatorContainer inactive={inactive}>
    <OperatorInformations>
      <OperatorImage src={imageUrl} alt={imageAlt} />
      <OperatorLabel> {label}</OperatorLabel>
    </OperatorInformations>

    <LinkArrow />
  </OperatorContainer>
);

export default Operator;
